

import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { discoveryState, listServices } from '../../features/discovery/discoverySlice';

export const useDiscovery = (): [boolean, boolean, string | null, string | null] => {
	const dispatch = useAppDispatch();
	const { isLoading, isSuccess, countryCode, country, isError } = useAppSelector(discoveryState);

	useEffect(() => {
		if (!isLoading && !isSuccess && !isError) {
			dispatch(listServices());
		}
	}, [dispatch, isLoading, isSuccess, isError]);

	return [isLoading, isSuccess, countryCode, country];
}
